var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUpCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.4,
    height: 22.4,
    viewBox: "0 0 22.4 22.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    transform: "translate(-147.6 -1009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    transform: "translate(210 363.15) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_46",
    transform: "translate(645.85 40)",
    fill: "#efefef",
    stroke: "#7d7d7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2,
    cy: 11.2,
    r: 10.7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    d: "M4.554,5.7.239,10.013a.815.815,0,1,0,1.154,1.151L6.281,6.28a.813.813,0,0,0,.024-1.124L1.4.238A.815.815,0,0,0,.243,1.388Z",
    transform: "translate(153.099 1023.459) rotate(-90)",
    fill: "#5f5f5f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.5b90378720f890da3bb356d2fbe09259.svg";
export { ForwardRef as ReactComponent };